class State {
  handleEvent(event, context, parser) {
    throw new Error('handleEvent not implemented');
  }
}

class NodeStartedToolState extends State {
  handleEvent(event, context, parser) {
    if (event.data.node_type === "tool") {
      context.answerLoading = 2;
      context.$set(context.dialoglist[context.index], "websearchState", 1);
      context.$set(context.dialoglist[context.index], "webSearchList", [{ text: context.$i18.language("正在尝试为您在互联网搜索相关资料..."), value: "" }]);
      context.$set(context.dialoglist[context.index], "sendContent", context.dialoglist[context.index].sendContent);
    }
  }
}

class NodeFinishedCodeState extends State {
  handleEvent(event, context, parser) {
    if (event.data.node_type === "code") {
      if (event.data.outputs && event.data.outputs.result) {
        let preResponse = context.preResponse;
        preResponse.webSearchList = event.data.outputs.result.length ? event.data.outputs.result : [{ text: context.$i18.language("暂未检索到互联网相关资料"), value: "" }];
        if (preResponse.webSearchList.length) {
          let tempSearchList = [];
          let i = 0;
          context.$set(context.dialoglist[context.index], "websearchState", 2);
          let webSearchTimer = setInterval(() => {
            if (i >= preResponse.webSearchList.length) return window.clearInterval(webSearchTimer);
            tempSearchList.push(preResponse.webSearchList[i]);
            context.$set(context.dialoglist[context.index], "webSearchList", tempSearchList);
            i += 1;
          }, 300);
        }
      }
    }
  }
}

class NodeStartedLLMState extends State {
  handleEvent(event, context, parser) {
    if (event.data.node_type === "llm") {
      context.preResponse.state = 1;
    }
  }
}

class MessageState extends State {
  handleEvent(event, context, parser) {
    if (context.preResponse.state === 1) {
      context.$set(context.dialoglist[context.index], "websearchState", 3);
      let reg = new RegExp('(?:<)?(https?:\\/\\/[^\\s，。；,;>\\u4e00-\\u9fa5]+)(?:>)?', 'g');
      context.preResponse.msg += event.answer;
      context.$set(context.dialoglist[context.index], "replyContent", context.preResponse.msg.replace(reg, '<a href="$1" target="_blank"> $1 </a>'));
    }
  }
}

class NodeFinishedLLMState extends State {
  handleEvent(event, context, parser) {
    if (event.data.node_type === "llm") {
      let preResponse = context.preResponse;
      preResponse.state = 2;
      preResponse = {
        ...preResponse,
        conversation_id: event.conversation_id,
        message_id: event.message_id,
        created_at: event.created_at,
        finished_at: event.data.finished_at,
      };
      context.preResponse = preResponse;
    }
  }
}

class Context {
  constructor() {
    this.states = {
      'node_started': {
        'tool': new NodeStartedToolState(),
        'llm': new NodeStartedLLMState(),
      },
      'node_finished': {
        'code': new NodeFinishedCodeState(),
        'llm': new NodeFinishedLLMState(),
      },
      'message': new MessageState(),
    };
    this.preResponse = {
      msg: '',
      data: {},
      state: 0,
      langChain: false,
      cacheMsg: "",
      webSearchList: [],
      scrollHeight: 0,
    };
    this.index = 0;
  }

  handleEvent(event, parser) {
    if (event.type === 'event') {
      let stateCategory = this.states[event.event];
      if (stateCategory) {
        let state = stateCategory[event.data.node_type] || stateCategory;
        if (state) {
          state.handleEvent(event, this, parser);
        }
      }
    }
  }
}

export default Context;